export class RunDPDataExportRequest {
    labId: string;
    runId: string;
    libraryIds: string[] = [];
    libLaneData: LibLaneData[] = [];
}

export class LibLaneData {
    libraryId: string;
    phix: number;
    laneId: string;
}